import Vue from 'vue'
import moment from 'moment'

Vue.filter('formatDate', value => moment(value).format('DD/MM/YYYY'))
Vue.filter('formatTime', value => moment(value, 'HH:mm:ss.SSSSSSS').format('HH:mm'))
Vue.filter('formatFullDate', value => moment(value).format('DD/MM/YYYY HH:mm'))
Vue.filter('formatFullDateWeek', value => moment(value).locale('es').format('dddd DD [de] MMMM [a las] HH:mm'))
